import React, { useState, useContext, useEffect, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import _, { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import InputReactSelect from 'modules/common/components/InputReactSelect';
import Select from 'react-select';
import * as actions from '../action';
import * as c from '../constant';

const INIT_FORM = {
  name: '',
  description: '',
  amount: '0',
  purposes: [],
  for_birth_certificate: 0,
  for_death_certificate: 0,
  for_marriage_certificate: 0,
  additional_copy_fee: '0',
  fee_type: '',
  is_documentary_stamp: 0
};

function FeeModal({
  createFee,
  updateFee,
  getFeeList,
  history,
  getSingleFee,
  creating,
  feeInfo,
  feeId,
  getPurposeList,
  purposeList,
  isPurposesLoading,
  filter,
}) {
  const [formData, setFormData] = useState(INIT_FORM);
  const setModal = useContext(ModalContext);
  const isNameLocked = _.get(feeInfo, 'is_name_locked');

  useEffect(() => {
    if (feeInfo) {
      const purposes = _.get(feeInfo, 'purposes', []).map((item) => ({
        label: _.get(item, 'name'),
        value: _.get(item, 'id'),
      }));
      const newForm = { ...feeInfo, purposes };
      setFormData(_.pick(newForm, _.keys(formData)));
    }
  }, [JSON.stringify(feeInfo)]);

  const validateForm = useFormValidator(formData, {
    name: 'required',
    description: 'required',
    amount: 'required',
    fee_type: 'required'
  });

  const handleSuccess = (data) => {
    setModal({ isOpen: false });
    getFeeList(filter);
    history.push(`/civil-registry/settings/fees/${_.get(data, 'id')}`);
    getSingleFee(data.id);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
      purposes: _.get(formData, 'purposes', []).map((item) => +item.value),
    };
    if (feeInfo) {
      updateFee(feeId, payload, ({ data }) => handleSuccess(data));
      return;
    }
    createFee(payload, ({ data }) => handleSuccess(data));
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [JSON.stringify(formData)]);

  useEffect(() => {
    getPurposeList();
  }, []);

  const purposeOptions = useMemo(() => {
    if (!purposeList || isEmpty(purposeList)) return [];

    return purposeList.map((item) => ({
      label: _.get(item, 'attributes.name'),
      value: _.get(item, 'id'),
    }));
  }, [purposeList]);

  const onCheck = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked ? 1 : 0,
    });
  };

  const handleOnChangeSelect = (e, key) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="name" className="form-label mb-1">
              Name {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
              disabled={feeInfo && isNameLocked}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="description" className="form-label mb-1">
              Description {validateForm.renderMessage('description')}
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label mb-1">
              Fee Type {validateForm.renderMessage('fee_type')}
            </label>
            <Select
              options={c.FEE_TYPE}
              onChange={(e) => handleOnChangeSelect(e, 'fee_type')}
              value={
                c.FEE_TYPE.find(
                  (x) => x.value === _.get(formData, 'fee_type')
                ) || null
              }
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="amount" className="form-label mb-1">
              Amount {validateForm.renderMessage('amount')}
            </label>
            <input
              className="form-control"
              type="number"
              name="amount"
              onChange={onChange}
              value={_.get(formData, 'amount')}
            />
          </div>
          {_.get(formData, 'fee_type') !== 'FIXED_RATE_FEE' ? (
            <div className="col-12 form-group">
              <label htmlFor="additional_copy_fee" className="form-label mb-1">
                Additional Copy Amount
              </label>
              <input
                className="form-control"
                type="number"
                name="additional_copy_fee"
                onChange={onChange}
                value={_.get(formData, 'additional_copy_fee')}
              />
            </div>
          ) : null}
          <div className="col-6 form-group">
            <input
              name="for_birth_certificate"
              type="checkbox"
              checked={_.get(formData, 'for_birth_certificate')}
              onChange={onCheck}
            />
            <label htmlFor="last_name" className="form-label mb-0">
              &nbsp; Birth Certificate
            </label>
          </div>
          <div className="col-6 form-group">
            <input
              name="is_documentary_stamp"
              type="checkbox"
              checked={_.get(formData, 'is_documentary_stamp')}
              onChange={onCheck}
            />
            <label htmlFor="last_name" className="form-label mb-0">
              &nbsp; DST
            </label>
          </div>
          <div className='col-12'>
            <div className="form-group">
              <input
                name="for_death_certificate"
                type="checkbox"
                checked={_.get(formData, 'for_death_certificate')}
                onChange={onCheck}
              />
              <label htmlFor="last_name" className="form-label mb-0">
                &nbsp; Death Certificate
              </label>
            </div>
            <div className="form-group">
              <input
                name="for_marriage_certificate"
                type="checkbox"
                checked={_.get(formData, 'for_marriage_certificate')}
                onChange={onCheck}
              />
              <label htmlFor="last_name" className="form-label mb-0">
                &nbsp; Marriage Certificate
              </label>
            </div>
          </div>
          <div className="col-12 form-group">
            <label htmlFor="amount" className="form-label mb-1">
              Purposes
            </label>
            <InputReactSelect
              name="purposes"
              value={formData.purposes}
              onChange={onChange}
              options={purposeOptions}
              isMulti // Enable multi-select
              placeholder="Search and select purposes..."
              // formatOptionLabel={formatOptionLabel}
              additional={{
                closeMenuOnSelect: false, // Keep menu open after selection
                menuPlacement: 'auto',
                // Optional: limit maximum selections
                // isOptionDisabled: () => formData.users.length >= 5,
              }}
              isLoading={isPurposesLoading}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

FeeModal.defaultProps = {
  feeInfo: undefined,
  feeId: undefined,
};

FeeModal.propTypes = {
  getFeeList: PropTypes.instanceOf(Function).isRequired,
  createFee: PropTypes.instanceOf(Function).isRequired,
  updateFee: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleFee: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  feeInfo: PropTypes.instanceOf(Object),
  feeId: PropTypes.string,
  getPurposeList: PropTypes.instanceOf(Function).isRequired,
  purposeList: PropTypes.instanceOf(Array).isRequired,
  isPurposesLoading: PropTypes.bool.isRequired,
  filter: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_FEE) > -1,
  purposeList: _.get(api, `${c.GET_PURPOSE_LIST}.list`) || [],
  isPurposesLoading: api.loading.indexOf(c.GET_PURPOSE_LIST) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(FeeModal);
